export default __webpack_public_path__ + "280b4a016b70235f61553abd2fd836be.jpeg";